import React from 'react';
import { motion } from 'framer-motion';
import { Check, AlertTriangle, Lock } from 'lucide-react';
import { Button } from './ui/Button';
export function CheckoutSection() {
  const handlePurchase = (url: string, price: number, name: string) => {
    // Track InitiateCheckout
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: name,
        currency: 'USD',
        value: price
      });
    }
    // Redirect
    window.location.href = url;
  };
  const combos = [{
    name: 'COMPLETO PARA EMPEZAR',
    price: 13.99,
    oldPrice: 27.99,
    discount: '50% OFF',
    features: ['Manual Principal Huerta 360º (PDF digital)', '3 Bonus Exclusivos (PDF digital)', 'Acceso automático por email', 'Acceso de por vida'],
    image: 'https://cdn.magicpatterns.com/uploads/g11yz5Ge345x3jkYLPDgxK/ChatGPT_Image_24_feb_2026,_15_07_28.png',
    link: 'https://pay.hotmart.com/U104645462P',
    recommended: false
  }, {
    name: 'MÁS ELEGIDO',
    price: 19.9,
    oldPrice: 39.9,
    discount: 'AHORRA $20',
    features: ['Todo lo del Combo 1', 'Manual 2: Huerta Intensiva (PDF digital)', 'Acceso automático por email', 'Acceso de por vida'],
    image: 'https://cdn.magicpatterns.com/uploads/6m5eYAacr2gLoLjeEM4sYz/ChatGPT_Image_24_feb_2026,_16_15_47.png',
    link: 'https://pay.hotmart.com/P104645626I',
    recommended: true
  }, {
    name: 'NIVEL EMPRENDEDOR',
    price: 26.9,
    oldPrice: 53.9,
    discount: 'MEJOR VALOR',
    features: ['Todo lo del Combo 1 y 2', 'Manual 3: Emprendimiento (PDF digital)', 'Acceso automático por email', 'Acceso de por vida'],
    image: 'https://cdn.magicpatterns.com/uploads/61gGfJb5mL4j38HMcDutYv/ChatGPT_Image_24_feb_2026,_16_33_57.png',
    link: 'https://pay.hotmart.com/Q104645750F',
    recommended: false
  }];
  return <section id="checkout" className="py-24 px-4 bg-zinc-950" data-id="element-41">
      <div className="max-w-7xl mx-auto" data-id="element-42">
        <div className="text-center mb-16" data-id="element-43">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-white mb-6" data-id="element-44">
            Elige Tu Nivel
          </h2>
          <motion.div animate={{
          opacity: [1, 0.7, 1]
        }} transition={{
          duration: 1.5,
          repeat: Infinity
        }} className="inline-flex items-center gap-2 bg-red-900/30 border border-red-500/50 text-red-400 px-4 py-2 rounded-lg font-bold mb-8" data-id="element-45">
            <AlertTriangle className="w-5 h-5" data-id="element-46" />
            Oferta con bonos por tiempo limitado
          </motion.div>

          {/* Secure payment badge with Hotmart */}
          <div className="flex flex-col items-center gap-3 mb-12" data-id="element-47">
            <div className="flex items-center gap-2 text-zinc-400 text-sm" data-id="element-48">
              <Lock className="w-4 h-4 text-green-500" data-id="element-49" />
              <span data-id="element-50">Pago 100% seguro procesado por</span>
            </div>
            <div className="bg-white px-5 py-3 rounded-lg" data-id="element-51">
              <img src="https://cdn.magicpatterns.com/uploads/g4uEDtvwrbY7ZFknKXtM5W/pasted-image.svg" alt="Hotmart" className="h-8 object-contain" data-id="element-52" />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start" data-id="element-53">
          {combos.map((combo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1
        }} viewport={{
          once: true
        }} className={`relative bg-zinc-900 rounded-2xl overflow-hidden border flex flex-col ${combo.recommended ? 'border-green-500 shadow-[0_0_30px_rgba(34,197,94,0.15)] scale-100 lg:scale-105 z-10' : 'border-zinc-800'}`} data-id="element-54">
              {combo.recommended && <div className="absolute top-0 inset-x-0 bg-green-600 text-white text-center text-sm font-bold py-1 uppercase tracking-wider" data-id="element-55">
                  Más Vendido
                </div>}

              <div className={`p-6 ${combo.recommended ? 'pt-10' : ''}`} data-id="element-56">
                <h3 className="text-xl font-bold text-white mb-6" data-id="element-57">
                  {combo.name}
                </h3>

                <div className="rounded-lg overflow-hidden bg-zinc-800 mb-6 border border-zinc-700 p-3" data-id="element-58">
                  <img src={combo.image} alt={combo.name} className="w-full h-56 object-contain" data-id="element-59" />
                </div>

                <ul className="space-y-3 mb-8" data-id="element-60">
                  {combo.features.map((feature, i) => <li key={i} className="flex items-start gap-3 text-sm text-zinc-300" data-id="element-61">
                      <Check className="w-5 h-5 text-green-500 shrink-0" data-id="element-62" />
                      {feature}
                    </li>)}
                </ul>

                <div className="text-center mb-4" data-id="element-63">
                  <span className="text-zinc-500 line-through text-sm" data-id="element-64">
                    USD ${combo.oldPrice.toFixed(2)}
                  </span>
                  <div className="text-3xl font-extrabold text-white" data-id="element-65">
                    USD ${combo.price.toFixed(2)}
                  </div>
                  <p className="text-xs text-zinc-500 mt-1" data-id="element-66">
                    Puedes pagar en tu moneda local: COP, CLP, MXN
                  </p>
                </div>

                <Button variant={combo.recommended ? 'primary' : 'secondary'} className="w-full" onClick={() => handlePurchase(combo.link, combo.price, combo.name)} data-id="element-67">
                  COMPRAR AHORA
                </Button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}